import { canPlayVideo } from 'lib/util';
class NodeFile {
  constructor({
    display_properties,
    file_attributes,
    file_size,
    file_type,
    file_url,
    uuid,
    preview_url,
    name,
    file,
  }) {
    this.display_properties = display_properties;
    this.file_attributes = file_attributes;
    this.file_size = file_size;
    this.file_type = file_type;
    this.file_url = file_url;
    this.uuid = uuid;
    this.preview_url = preview_url;
    this.file = file;
    this.name = name;
  }

  static create({ nodeUUID, isNew, file, canvas }) {
    this.node = store.getNode(nodeUUID);
    if (isNew) {
      let displayProperties;
      if (canPlayVideo(file.type)) {
        displayProperties = { size: canvas.defaultImageSize };
      }

      return new NodeFile({
        file_size: file.size,
        file_type: file.type || 'application/octet-stream',
        name: file.name,
        display_properties: displayProperties,
        file,
      });
    } else {
      return new NodeFile({
        display_properties: this.node.attachedFile.display_properties,
        file_attributes: this.node.attachedFile.file_attributes,
        file_size: this.node.attachedFile.file_size,
        file_type: this.node.attachedFile.file_type,
        file_url: this.node.attachedFile.file_url,
        uuid: this.node.attachedFile.uuid,
        preview_url: this.node.attachedFile.preview_url,
        name: this.node.attachedFile.name,
      });
    }

  }

  getPreviewFileUrl() {
    return 'https://s3.amazonaws.com/plectica-app-assets/file-icon.svg';
  }

  getFile() {
    return this.file;
  }
}

export default NodeFile;



// WEBPACK FOOTER //
// ./starling/src/lib/node-file.js